const TIPO_TRANSCRICAO_LABELS: Record<string, string> = {
  NORMAL: 'Normal',
  BUCO: 'Buco Maxilo Facial',
  TERESP: 'Terapias Especiais',
};

export const formatTranscricaoDataCompleta = (raw?: string): string => {
  if (!raw?.trim()) return '—';

  const trimmed = raw.trim();

  if (trimmed.includes('às')) {
    return trimmed;
  }

  if (trimmed.includes('/')) {
    const [datePart, timePart] = trimmed.split(/\s+/);
    if (timePart) {
      const hora = timePart.length === 5 ? `${timePart}:00` : timePart;
      return `${datePart} às ${hora}`;
    }
    return datePart;
  }

  const parsed = new Date(trimmed);
  if (!Number.isNaN(parsed.getTime())) {
    const dia = String(parsed.getDate()).padStart(2, '0');
    const mes = String(parsed.getMonth() + 1).padStart(2, '0');
    const ano = parsed.getFullYear();
    const hora = String(parsed.getHours()).padStart(2, '0');
    const minuto = String(parsed.getMinutes()).padStart(2, '0');
    const segundo = String(parsed.getSeconds()).padStart(2, '0');
    return `${dia}/${mes}/${ano} às ${hora}:${minuto}:${segundo}`;
  }

  return trimmed;
};

export const getTipoTranscricaoLabel = (codTipo?: string): string => {
  if (!codTipo?.trim()) return '—';
  return TIPO_TRANSCRICAO_LABELS[codTipo.trim().toUpperCase()] ?? codTipo;
};
